import { render, staticRenderFns } from "./ModalPayment.vue?vue&type=template&id=e4241b44&"
import script from "./ModalPayment.vue?vue&type=script&lang=js&"
export * from "./ModalPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports